import React from 'react';

import GraphGrid from './GraphGrid';
import { extraSectionsOf } from './beforeAfter';

/**
 * LES SECTIONS QU'UNE PAGE DE BILAN AJOUTE À SON ÉCRAN, décrites par des données
 * (`content.metadata.extra_sections : [{title, hint, list_graph}]`).
 *
 * C'est ce qui évite d'écrire un écran de fin par client : les graphes sont ceux
 * d'une page `score`, montés par le même GraphGrid. Sans sections, rien ne
 * s'affiche, et le bilan reste celui d'avant.
 */
const BoardSections = ({ pageData, gameStatus }) => (
  <>
    {extraSectionsOf(pageData?.content).map((section, index) => (
      <React.Fragment key={index}>
        {section.title && <h2 className="board-section">{section.title}</h2>}
        {section.hint && <p className="board-section-hint">{section.hint}</p>}
        <GraphGrid listGraph={section.list_graph} gameStatus={gameStatus} />
      </React.Fragment>
    ))}
  </>
);

export default BoardSections;
